import * as R from 'ramda'
import {
    FETCH_TITLE_SUCCESS
} from '../actionTypes'

const InitialState = '';

export default (state = InitialState, {type, payload}) => {
    switch (type) {
        case FETCH_TITLE_SUCCESS:
            return payload
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/title.js